module.exports = __webpack_public_path__ + "img/img_stamp_color.b07af143.png";